export enum PassportFormType {
   "WITH_SAME_CONDITION" = "WITH_SAME_CONDITION",
   "WITH_DIFFERENT_CONDITION" = "WITH_DIFFERENT_CONDITION"
}
